export const STATUSES = ["in_progress", "applied", "interview", "rejected", "offer"];

export const STATUS_LABELS = {
  in_progress: "In Progress",
  applied: "Applied",
  interview: "Interview",
  rejected: "Rejected",
  offer: "Offer",
};

export const STATUS_STYLES = {
  in_progress: "bg-[#E8A93C]/15 text-[#8a6410]",
  applied: "bg-blue-100 text-blue-800",
  interview: "bg-amber-100 text-amber-800",
  rejected: "bg-red-100 text-red-800",
  offer: "bg-green-100 text-green-800",
};

export const statusLabel = (s) => STATUS_LABELS[s] || s;
